<div class="admin-referrals">
  <h1 id="referral-leaderboard-heading" class="mb-4 text-2xl font-semibold text-gray-800">Referral leaderboard</h1>

  <div class="table-card">
    <div class="table-toolbar">
      <div class="table-toolbar__filters">
        <mat-form-field appearance="outline">
          <mat-label>Search text</mat-label>
          <mat-icon matPrefix class="mr-2 text-gray-400">search</mat-icon>
          <input matInput [formControl]="searchControl" placeholder="Email, name, state code..." />
        </mat-form-field>
      </div>
    </div>

    <table mat-table [dataSource]="leaderboard" aria-labelledby="referral-leaderboard-heading">
      <ng-container matColumnDef="rank">
        <th mat-header-cell *matHeaderCellDef>Rank</th>
        <td mat-cell *matCellDef="let r; let i = index" class="table-rank" [class.table-rank--top]="rank(i) <= 3">
          #{{ rank(i) }}
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Corper</th>
        <td mat-cell *matCellDef="let r">
          <div class="cell-identity">
            <span class="cell-identity__avatar">{{ r | initials }}</span>
            <div class="cell-identity__text">
              <div class="cell-identity__primary">{{ referrerDisplay(r) }}</div>
              <div class="cell-identity__secondary">{{ r.email || '—' }}</div>
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="state_code">
        <th mat-header-cell *matHeaderCellDef>State code</th>
        <td mat-cell *matCellDef="let r">{{ r.state_code || '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="referral_count">
        <th mat-header-cell *matHeaderCellDef>Referrals</th>
        <td mat-cell *matCellDef="let r"><span class="table-chip">{{ r.referral_count }}</span></td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="['rank', 'name', 'state_code', 'referral_count']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['rank', 'name', 'state_code', 'referral_count']"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell py-4 text-center text-gray-500" colspan="4">
          <span *ngIf="loading">Loading…</span>
          <span *ngIf="!loading && leaderboard.length === 0">No referrals yet</span>
        </td>
      </tr>
    </table>
    <mat-paginator
      [length]="totalReferrals ?? 0"
      [pageIndex]="page - 1"
      [pageSize]="limit"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
      (page)="onPageChange($event)"
    ></mat-paginator>
  </div>
</div>
